import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Shell } from "./ui";

const Loading = () => (
  <Shell><div className="mt-24 text-center text-[#00D26A] tracking-widest">LOADING…</div></Shell>
);

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function RequirePlatform({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.platform_role) return <Navigate to="/dashboard" replace />;
  return children;
}
